<template>
  <div>
    查詢訂單
<!--    //QQ pending-->
    <a role="button" class="btn btn-primary" :class="queryStatus==='pending' ? 'active' :'' "  @click="QueryStatus('pending')">待付款</a>
    <a role="button" class="btn btn-primary" :class="queryStatus==='payed' ? 'active' :'' " @click="QueryStatus('payed')">已付款</a>
    <a role="button" class="btn btn-primary" :class="queryStatus==='completed' ? 'active' :'' " @click="QueryStatus('completed')">已完成</a>
    <a role="button" class="btn btn-primary" :class="queryStatus==='cancelled' ? 'active' :'' " @click="QueryStatus('cancelled')">已取消</a>

    匯出
    <a role="button" class="btn btn-info" onclick="ExportToExcel()">匯出Excel</a>

    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
<!--        <th>功能</th>-->
        <th>訂單編號</th>
        <th>交易時間</th>
        <th>訂購內容</th>
        <th>訂購人資訊</th>
        <th>收件人資訊</th>
        <th>發票類型</th>
        <th>運送方式</th>
        <th>付款方式</th>
        <th>緣金總計</th>
        <th>訂單狀態</th>
        <th>備註</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(item, index) in datas" :key="index">
<!--        <td width="100px">-->
<!--          <a role="button" class="btn btn-primary" href="#" @click="gotoDetail(item.id)">名單</a>-->

<!--          &lt;!&ndash;          <span v-if="item.status==='expired'">&ndash;&gt;-->
<!--          &lt;!&ndash;            <a role="button" class="btn btn-danger" href="#" @click="deleteDetail(item.id)">刪除</a>&ndash;&gt;-->
<!--          &lt;!&ndash;          </span>&ndash;&gt;-->
<!--        </td>-->
        <td>{{ item.orderNo }}</td>
        <td>{{ item.orderDt | fmtDateUTC }}</td>
        <td>
          <ul>
            <li v-for="detail in item.details" :key="detail.id">
              {{ detail.productName }} {{detail.specText}} - {{ detail.quantity }} x {{ detail.price }}
            </li>
          </ul>
        </td>
        <td>
          {{ item.order_name }} ({{ item.order_sex === 'm' ? '男' : '女' }}) <br>
          {{ item.order_email }}<br>
          {{ item.order_mtel }}<br>
          {{ item.order_address1 }} {{ item.order_address2 }}
        </td>
        <td>
          {{ item.rec_name }} ({{ item.rec_sex === 'm' ? '男' : '女' }}) <br>
          {{ item.rec_mtel }}<br>
          {{ item.rec_address1 }} {{ item.rec_address2 }}
        </td>
        <td>{{ item.invoiceType === '2' ? '二聯式' : '三聯式'}} {{item.invoiceTitle ? "(" +item.invoiceTitle  +"/":"" }} {{item.invoiceNumReg ? item.invoiceNumReg +")":"" }} </td>
        <td>{{ item.shipWay=== 'taiwan' ? '本島' : '外島' }} </td>
        <td>{{ item.payType=== 'card' ? '信用卡' : '其他' }}</td>
        <td>{{ item.totalAmount }}</td>
        <td>

<!--          //QQ-->
          <div v-if="item.status==='pending'" >
            待付款
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'payed')">改為已付款</a>
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'completed')">改為已完成</a>
            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,'cancelled')">改為取消</a>
          </div>
          <div v-else-if="item.status==='payed'">
            已付款
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'completed')">改為完成</a>
            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,'cancelled')">改為取消</a>
          </div>
          <div v-else-if="item.status==='completed'">
            已完成
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'payed')">改為未完成(已付款)</a>
            <a role="button" class="btn btn-danger" href="#" @click="changeStatus(item.id,'cancelled')">改為取消</a>
          </div>
          <div v-else-if="item.status==='cancelled'">
            已取消
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'completed')">改為已完成</a>
            <a role="button" class="btn btn-primary" href="#" @click="changeStatus(item.id,'pending')">改為未完成(已付款)</a>
<!--            //QQ-->
          </div>
          <div v-else>

          </div>

        </td>
        <td>{{ item.order_memo }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import Vue from "vue";
import apiFireGodsec from "@/views/fireGods/js/apiFireGodsec";

export default {
  data() {
    return {
      datas: [],
      queryStatus: "payed",
    };
  },
  methods: {
    QueryStatus(status) {
      this.queryStatus = status;
      this.loadData();
    },
    loadData() {
      apiFireGodsec.api_Admin_ECOrderList_Query(this.queryStatus).then((response) => {
        this.datas = response.data.data;

        for (let i = 0; i < this.datas.length; i++) {
          for (let j = 0; j < this.datas[i].details.length; j++) {
            this.datas[i].details[j].specText = "";
            if (this.datas[i].details[j].spec) {
              this.datas[i].details[j].specText = " (" + this.datas[i].details[j].spec + ")";
            }
          }
        }
      });
    },
    changeStatus(id,status){
      apiFireGodsec.api_Admin_ECOrderList_ChangeStaus(id,status).then((data)=>{
        console.log(data);
        alert('儲存成功')
        this.loadData();
      })
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>

<style scoped>
#tblMain {
  width: 100%;
}
.btn {
  color: white !important;
  margin: 5px;
}
</style>
